var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"px-2 mx-3 mt-3",attrs:{"align":"center"}},_vm._l((_vm.words),function(ref){
var word_en = ref.word_en;
var word_fr = ref.word_fr;
var count = ref.count;
var i = ref.i;
return _c('p',{key:i,staticClass:"mx-2 px-2 py-1 white--text",staticStyle:{"background":"#2a69b0"}},[_vm._v(" "+_vm._s(_vm.lang === "en" ? word_en : word_fr)+" ("+_vm._s(count)+") ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }